// extracted by mini-css-extract-plugin
module.exports = {"container":"Accordion_container__VDxMf"};